export const formattedYear = (value: string): string => {
    let number = Number(value);

    if (number < 100) {
        number += number >= 30 ? 1900 : 2000;
    }

    return number.toString();
};
